import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import TimeTravel from 'components/TimeTravel';

import {Settings} from './components/Settings';
import {SettingsMap, SettingsType} from '../../dashboardSettingsTypes';


export function Header(
  props: {
    confirmText: React.ReactNode
    dashboardSettings: SettingsType
    description: React.ReactNode
    defaultDashboardSettings: SettingsType
    hideSettings?: boolean
    onSettingsClose: CallableFunction
    saveDashboardSettings: CallableFunction
    settingsMap: SettingsMap
    submitText: string
    title: React.ReactNode|string
}) {
  const [openSettings, setOpenSettings] = useState(false);

  const close = () => {
    setOpenSettings(false);
    props.onSettingsClose();
  };

  return (
    <div className="bg-white w-100 mt-4 mb-2">
      <div className="d-flex container align-items-center justify-content-between">
        {!props.hideSettings &&
          <Settings
            confirmText={props.confirmText}
            defaultDashboardSettings={props.defaultDashboardSettings}
            description={props.description}
            dashboardSettings={props.dashboardSettings}
            close={close}
            isOpen={openSettings}
            settingsMap={props.settingsMap}
            submitText={props.submitText}
            saveDashboardSettings={props.saveDashboardSettings}
          />
        }
        <Typography variant="h1" className="m-3">{props.title}</Typography>
        <div className="d-flex flex-row">
          {!props.hideSettings &&
            <IconButton
              size="small"
              className="mr-2"
              onClick={() => setOpenSettings(true)}
            >
              <SettingsOutlinedIcon/>
            </IconButton>
          }
          <TimeTravel/>
        </div>
      </div>
    </div>
  );
}
